import { UIAccordion } from '@/components/ui/Accordion';
import { UIBox } from '@/components/ui/Box';
import { UICheckbox } from '@/components/ui/Checkbox';
import { GridRecapStyles } from '@/pages/Receiving/PageReceivingRecap/ProductList/style';
import { colors } from '@/theme';
import { ADJUSTMENT_NEGATIVE, ADJUSTMENT_POSITIVE } from '@/utils/const';
import styled from 'styled-components';

export const StyledProductItem = styled(UIBox)`
  flex-direction: column;
  padding: 20px 0 !important;
  background: #fbfbfb;
  padding: 0;
  align-content: start;

  &:not(:last-of-type) {
    border-bottom: 1px solid #ededed;
  }
`;

export const StyledProductContent = styled(UIBox)`
  position: relative;
  align-items: center;
  display: grid;
  justify-content: space-between;
  ${GridRecapStyles}

  &::before {
    content: '';
    border-radius: 100px;
    position: absolute;
    left: -20px;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 6px;
    height: 45px;
    background: ${colors.grey};
  }
`;

export const StyledAccordion = styled(UIAccordion)`
  &&& {
    width: 32px;
    height: 32px;
    margin: 0 8px 0 -8px !important;
  }
`;

export const StyledCheckbox = styled(UICheckbox)`
  &&& {
    margin: 0 8px !important;
    width: 32px;
    height: 32px;
  }
`;

export const StyledContentInfo = styled(UIBox)`
  align-items: center;
  width: 100%;
`;

export const StyledUIBox = styled(UIBox)`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  width: 100%;
`;

export const StyledCountWrapper = styled(UIBox)<{ $movementType?: string }>`
  align-items: flex-end;
  flex-direction: column;
  width: 100%;

  span {
    color: ${({ $movementType }): string =>
      $movementType && ADJUSTMENT_NEGATIVE.includes($movementType)
        ? colors.red
        : $movementType && ADJUSTMENT_POSITIVE.includes($movementType)
        ? colors.green
        : colors.black} !important;
  }
`;

export const StyledDescription = styled(UIBox)`
  flex-direction: column;
  margin: 0 16px;
`;

export const StyledActionWrapper = styled(UIBox)`
  align-items: center;
  aling-self: flex-end;
  margin-left: 32px;
`;

export const StyledAccordionContent = styled(UIBox)<{ ml: string }>`
  flex-direction: column;
  padding: 24px 0;
  margin-left: ${({ ml }): string => ml};
`;

export const StyledAccordionItemContent = styled(UIBox)`
  width: 100%;
  align-items: center;

  &:not(:last-of-type) {
    margin-bottom: 18px;
  }
`;
